import React, { useEffect, useState } from "react";
import { useForm } from "../../hooks/useForm";
import { ModalDocumento } from "../Otros/ModalDocumento";
import { Popup } from "semantic-ui-react";
import {
  cargarPrecalificaciones,
  cargarCalificacionFinal,
  anularCalificacion,
} from "../../utils/Datos";
import { Textos } from "../../utils/Global";
import Swal from "sweetalert2";
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";

export const ListarPrecalificaciones = ({ id_participant = null }) => {
  const [datosPrecalificaciones, setdatosPrecalificaciones] = useState(null);
  const [datosCalificacionFinal, setdatosCalificacionFinal] = useState(null);
  const user = useSelector(selectUser);


  useEffect(() => {
    cargarPrecalificaciones(id_participant).then((precalificaciones) => {
      if (precalificaciones !== null) {
        //
        setdatosPrecalificaciones(precalificaciones);
        console.log(datosPrecalificaciones);
      }
    });
  }, []);

  useEffect(() => {
    cargarCalificacionFinal(id_participant).then((calificacionfinal) => {
      if (calificacionfinal !== null) {
        if (calificacionfinal.status) {
          setdatosCalificacionFinal(calificacionfinal);
        } else {
          setdatosCalificacionFinal(null);
        }
      }
    });
  }, []);

  const hayPrecalificacionesPendientes =
  Array.isArray(datosPrecalificaciones) &&
  datosPrecalificaciones.some(
    (dato) => dato.is_active && !dato.statusValidationFun
  );


  const handleAnular=(d)=>{
    console.log(d.id_preQualifications);
    Swal.fire({
      title: 'Escribe un comentario',
      input: 'textarea',
      inputPlaceholder: 'Escribe tu comentario aquí...',
      inputAttributes: {
        'aria-label': 'Escribe tu comentario aquí'
      },
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value) {
          return '¡Debes ingresar un comentario!';
        }
      }
    }).then((result) => {
      if (result.isConfirmed) {
        const comentario = result.value; // El comentario ingresado por el usuario
        // Llamar a la función que recibe el comentario
        let payload={
          id_preQualifications:d.id_preQualifications,
          internal_comment:comentario,
          officer_id_session:user.user.id_officer
        }
        anularCalificacion(payload).then((respuesta)=>{
          if (respuesta.status) {
            Swal.fire({icon:'success',title:'Correcto',text:'Calificación anulada con éxito'}).then((okay)=>{
              if (okay) {
                window.location.reload();
              }
            })
          }else{
            Swal.fire({icon:'error',title:'error',text:respuesta.errores})
          }
        });
      }
    });
  }

  return datosPrecalificaciones !== null ? (
    <div className="col-xl-12 ">
      <div className="card ">
        <div className="card-header ">
          <h3 className="card-title align-items-start flex-column ">
            <span className="card-label fw-bolder text-dark ">
               VER EVALUACIONES DE {Textos.comun_FUNCIONARIO}
            </span>
          </h3>
        </div>
        <div className="card-body ">
          <div className="col-xl-12 mt-5">
            <div className="table-responsive">
              <h4 className="text-gray-900 fw-bolder">Etapas de evaluación</h4>
              <table className="table table-rounded  border gy-7 gs-7 table-bordered">
                <thead>
                  <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                    <th>Etapa</th>
                    <th>SF11</th>
                    <th>SF12</th>
                    <th>NOTA</th>
                    <th>PTJE F1</th>
                    <th>SF21</th>
                    <th>SF22</th>
                    <th>SF23</th>
                    <th>NOTA</th>
                    <th>PTJE F2</th>
                    <th>SF31</th>
                    <th>SF32</th>
                    <th>NOTA</th>
                    <th>PTJE F3</th>
                    <th>FINAL</th>
                    <th>LISTA</th>
                    <th>DOCUMENTOS</th>
                    <th>ANULAR</th>
                  </tr>
                </thead>
                <tbody>
                  {datosPrecalificaciones === null ? (
                    <tr>
                      <td colSpan={17} className="text-center">
                        No se encontraron datos
                      </td>
                    </tr>
                  ) : (
                    datosPrecalificaciones.map((d, index) => {
                      //if (d.statusQualificationPre) {
                        if (d.is_active) {
                           return (
                          <tr
                            className={
                              !d.statusValidationFun ? "trWarning" : ""
                            }
                            key={`tr_${index}`}
                          >
                            <td>
                              {!d.statusValidationFun ? (
                                <Popup
                                  content={
                                    "Esta calificación no ha sido validada por " +
                                    Textos.comun_el_funcionario
                                  }
                                  trigger={
                                    <i className="text-dark fas fa-exclamation-triangle mr-2"></i>
                                  }
                                />
                              ) : (
                                <Popup
                                  content={
                                    "Esta calificación ha sido validada por " +
                                    Textos.comun_el_funcionario
                                  }
                                  trigger={
                                    <i className="text-success fas fa-check mr-2"></i>
                                  }
                                />
                              )}
                              {d.name}
                            </td>
                            <td>{d.subFactor11}</td>
                            <td>{d.subFactor12}</td>
                            <td>{d.qualificationFactor1}</td>
                            <td>{d.scoreFactor1}</td>
                            <td>{d.subFactor21}</td>
                            <td>{d.subFactor22}</td>
                            <td>{d.subFactor23}</td>

                            <td>
                              {d.qualificationFactor2}
                            </td>
                            <td>{d.scoreFactor2}</td>

                            <td>{d.subFactor31}</td>
                            <td>{d.subFactor32}</td>
                            <td>{d.qualificationFactor3}</td>
                            <td>{d.scoreFactor3}</td>
                            <td>
                              <span className="badge badge-primary">
                                {d.scoreFinal}
                              </span>
                            </td>
                            <td>{d.list}</td>
                            <td>
                                  <button
                                  className="btn btn-primary"
                                  onClick={()=>{
                                    if ( d.file.contentByte==null ||  d.file.contentByte=="") {
                                      Swal.fire({icon:'error',text:'El documento no se encuentra disponible'})
                                    }else{

                                      const base64toBlob = (data) => {
                                        const bytes = atob(data);
                                        let length = bytes.length;
                                        let out = new Uint8Array(length);
                                    
                                        while (length--) {
                                          out[length] = bytes.charCodeAt(length);
                                        }
                                    
                                        return new Blob([out], { type: "application/pdf" });
                                      };
                                    
                                      const blob = base64toBlob(d.file.contentByte);
                                      const url = URL.createObjectURL(blob);

                                      const pdfWindow = window.open();
                                      pdfWindow.location.href = url;      
                                    }
                                    
                                  }}>Ver</button>
                              { /*
                              <button
                                className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                                data-bs-toggle="modal"
                                data-bs-target={`#modal22${index}`}
                              >
                                 ver
                              </button>

                              <ModalDocumento
                                id={`modal22${index}`}
                                documentoByte={
                                  d.file === null ? null : d.file.contentByte
                                }
                              /> */}
                            </td>
                            <td>
                              <button onClick={() => handleAnular(d)} className="btn btn-danger">Anular</button>
                            </td>
                          </tr>
                        );
                        }else{
                           return (
                          <tr
                            className={
                              !d.statusValidationFun ? "trWarning" : ""
                            }
                            key={`tr_${index}`}
                          >
                            <td colSpan={18}>
                              <div className="alert alert-warning" role="alert">
                                <strong>
                                  <i className="fas fa-exclamation-triangle"></i>
                                </strong>{" "}
                                   <b>{d.name}</b> - Esta evaluación ha sido anulada
                              </div>
                            </td>
                           
                          </tr>
                        );
                        }
                       
                      /*} else {
                        return (
                          <tr key={`tr_${index}`}>
                            <td>{d.name}</td>
                            <td colSpan={16}>
                              <div className="alert alert-warning" role="alert">
                                <strong>
                                  <i className="fas fa-exclamation-triangle"></i>
                                </strong>{" "}
                                Aún no hay registros para esta evaluación
                              </div>
                            </td>
                          </tr>
                        );
                      } */
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {hayPrecalificacionesPendientes ?  (
            <></>
          ) : (
            <div className="col-md-12">
              <div className="table-responsive mt-8">
                <h4 className="text-gray-900 fw-bolder mt-5 mb-5">
                  Calificación Final
                </h4>
                {datosCalificacionFinal === null ? (
                  <div className="alert alert-warning" role="alert">
                    <strong>
                      <i className="fas fa-exclamation-triangle"></i>
                    </strong>{" "}
                    La etapa de calificación aún no ha sido realizada
                  </div>
                ) : datosCalificacionFinal.datos.ratification !== null ? (
                  <table className="table table-rounded  border gy-7 gs-7 table-bordered">
                    <thead>
                      <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200 ">
                        <th></th>
                        <th>SF11</th>
                        <th>SF12</th>
                        <th>NOTA</th>
                        <th>PTJE F1</th>
                        <th>SF21</th>
                        <th>SF22</th>
                        <th>SF23</th>
                        <th>NOTA</th>
                        <th>PTJE F2</th>
                        <th>SF31</th>
                        <th>SF32</th>
                        <th>NOTA</th>
                        <th>PTJE F3</th>
                        <th>FINAL</th>
                        <th>LISTA</th>
                        <th>DOCUMENTOS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        className={
                          !datosCalificacionFinal.datos.accordanceStatus == null
                            ? "trWarning"
                            : ""
                        }
                        key={`tr_calificacionfinal`}
                      >
                        <td>
                          {datosCalificacionFinal.datos.accordanceStatus == null ? (
                            <Popup
                              content={
                                "Esta calificación no ha sido validada por " +
                                Textos.comun_el_funcionario
                              }
                              trigger={
                                <i className="text-dark fas fa-exclamation-triangle mr-2"></i>
                              }
                            />
                          ) : (
                            <Popup
                              content={
                                "Esta calificación ha sido validada por " +
                                Textos.comun_el_funcionario
                              }
                              trigger={
                                <i className="text-success fas fa-check mr-2"></i>
                              }
                            />
                          )}
                          </td>
                        <td>
                          {datosCalificacionFinal.datos.subFactor11}
                        </td>
                        <td>{datosCalificacionFinal.datos.subFactor12}</td>
                        <td>
                          {datosCalificacionFinal.datos.qualificationFactor1}
                        </td>
                        <td>{datosCalificacionFinal.datos.scoreFactor1}</td>
                        <td>{datosCalificacionFinal.datos.subFactor21}</td>
                        <td>{datosCalificacionFinal.datos.subFactor22}</td>
                        <td>{datosCalificacionFinal.datos.subFactor23}</td>
                        <td>
                          {datosCalificacionFinal.datos.qualificationFactor2}
                        </td>
                        <td>{datosCalificacionFinal.datos.scoreFactor2}</td>
                        <td>{datosCalificacionFinal.datos.subFactor31}</td>
                        <td>{datosCalificacionFinal.datos.subFactor32}</td>
                        <td>
                          {datosCalificacionFinal.datos.qualificationFactor3}
                        </td>
                        <td>{datosCalificacionFinal.datos.scoreFactor3}</td>
                        <td>
                          <span className="badge badge-primary">
                            {datosCalificacionFinal.datos.finalScore}
                          </span>
                        </td>
                        <td>{datosCalificacionFinal.datos.list}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                            data-bs-toggle="modal"
                            data-bs-target="#modalCalificacionFinal"
                          >
                             VER
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <>
                    <div className="alert alert-warning" role="alert">
                      <strong>
                        <i className="fas fa-exclamation-triangle"></i>
                      </strong>{" "}
                      La calificación no ha sido ratificada
                    </div>
                  </>
                )}
              </div>
            </div>
          )}
          {/**Si ratification.ratificationStatus == true mostrar esto si no no. */}

          {hayPrecalificacionesPendientes ?  (
            <></>
          ) : datosCalificacionFinal !== null &&
            datosCalificacionFinal.datos.ratification !== null ? (
            <>
              <div className="col-xl-12 mt-5">
                {datosCalificacionFinal === null ? (
                  <></>
                ) : 
                
                datosCalificacionFinal.accordanceStatus!=null ?
                  <div className="row">
                    <div className="col-xl-4 mt-5">
                      <div className="notice d-flex  rounded border-info border border-dashed mb-12 p-6">
                        <div className="d-flex flex-stack flex-grow-1">
                          <div className="fw-bold">
                            <h4 className="text-gray-900 fw-bolder mb-5">
                              Respuesta funcionario
                            </h4>

                            <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                              <input
                                className="form-check-input"
                                type="radio"
                                defaultValue=""
                                name="conforme"
                                id="conforme-si"
                                readOnly
                                checked={
                                  datosCalificacionFinal != null &&
                                  datosCalificacionFinal.datos
                                    .accordanceStatus === "CONFORME"
                                    ? "checked"
                                    : ""
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="conforme-si"
                              >
                                CONFORME
                              </label>
                            </div>
                            <div className="form-check form-check-custom form-check-danger form-check-solid">
                              <input
                                className="form-check-input"
                                type="radio"
                                defaultValue=""
                                name="conforme"
                                id="conforme-no"
                                readOnly
                                checked={
                                  datosCalificacionFinal != null &&
                                  datosCalificacionFinal.datos
                                    .accordanceStatus === "DISCONFORME"
                                    ? "checked"
                                    : ""
                                }
                              />
                              <label
                                className="form-check-label"
                                htmlFor="conforme-no"
                              >
                                DISCONFORME
                              </label>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                    {
                         datosCalificacionFinal != null &&
                         datosCalificacionFinal.datos
                           .accordanceStatus === "CONFORME" ? <></>:
                          <div className="col-xl-4 mt-5">
                            <div className="notice d-flex  rounded border-danger border border-dashed mb-12 p-6">
                              <div className="d-flex flex-stack flex-grow-1">
                                <div className="fw-bold">
                                  <h4 className="text-gray-900 fw-bolder mb-5">
                                    Apelación
                                  </h4>
                                  <div className="form-check form-check-custom form-check-success form-check-solid mb-5">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      defaultValue=""
                                      name="apelar"
                                      id="apelar"
                                      readOnly
                                      checked={
                                        datosCalificacionFinal != null &&
                                        datosCalificacionFinal.datos.appeal !=null
                                          ? "checked"
                                          : ""
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="apelar"
                                    >
                                      Funcionario Apelará
                                    </label>
                                  </div>
                                  <div className="form-check form-check-custom form-check-danger form-check-solid">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      defaultValue=""
                                      name="apelar"
                                      id="no-apelar"
                                      readOnly
                                      checked={
                                        datosCalificacionFinal !=null &&
                                        datosCalificacionFinal.datos.appeal == null
                                          ? "checked"
                                          : ""
                                      }
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="no-apelar"
                                    >
                                      No apelará
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                    }
                    
                    { /*}
                    <div className="col-xl-4 mt-5">
                      <div className="notice d-flex  rounded border-danger border border-dashed mb-12 p-6">
                        <div className="d-flex flex-stack flex-grow-1">
                          <div className="fw-bold">
                            <h4 className="text-gray-900 fw-bolder mb-5">
                              Fecha
                            </h4>
                            <strong className="mb-8">Fecha: 22/00/2022</strong>
                            <br />
                            <strong className="mb-8">
                              Firmado con clave unica
                            </strong>
                          </div>
                        </div>
                      </div>
                              </div>*/}
                  </div> : <></>

                  
                 
                }

                {datosCalificacionFinal !== null &&
                datosCalificacionFinal.datos.appeal != null ? (
                  <div className="row">
                    <div className="table-responsive mt-8">
                      <h4 className="text-gray-900 fw-bolder mt-5 mb-5">
                        Proceso de Apelación
                      </h4>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>

              <div className="card-footer d-flex justify-content-end py-6 px-9">
                {datosCalificacionFinal !== null &&
                datosCalificacionFinal.datos.appeal != null ? (
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#modalApelacion"
                    className="btn btn-light btn-active-light-primary me-2"
                  >
                     Ver documentos Apelación
                  </button>
                ) : (
                  <></>
                )}

                {datosCalificacionFinal !== null ? (
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#modalCalificacionFinal"
                    className="btn btn-primary px-6 d-none"
                  >
                     Ver calificación Final
                  </button>
                ) : (
                  <></>
                )}
              </div>

              <ModalDocumento
                id="modalApelacion"
                documentoByte={
                  datosCalificacionFinal !== null &&
                  datosCalificacionFinal.datos.appeal !== null &&
                  datosCalificacionFinal.datos.appeal.document !== null
                    ? datosCalificacionFinal.datos.appeal.document.contentByte
                    : null
                }
              />
              <ModalDocumento
                id="modalCalificacionFinal"
                documentoByte={
                  datosCalificacionFinal !== null
                    ? datosCalificacionFinal.datos.qualificationDocument
                        .contentByte
                    : null
                }
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};
